import { UpdateAccountRequestSchema, UpdateAccountResponseSchema } from './update-account.schema';
/**
 * Update Account Endpoint Contract
 * Assign a HubSpot company, or nest the account under a parent. Super-admin only.
 */ export const updateAccountContract = {
    method: 'PATCH',
    path: '/api/v2/admin/accounts/:accountId',
    description: 'Assign an account its company, or nest it under a parent',
    requestSchema: UpdateAccountRequestSchema,
    responseSchema: UpdateAccountResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            400: 'Bad Request - company already taken, or the parent would form a cycle',
            401: 'Unauthorized - invalid or missing token',
            403: 'Forbidden - not a super-admin',
            404: 'Not Found - no such account'
        }
    }
};

//# sourceMappingURL=update-account.contract.js.map